module.exports = __webpack_public_path__ + "static/media/1POLICY40.a07cc594.jpg";